export { Idle } from './idle';
export { NotIdle } from './not-idle';
//# sourceMappingURL=/Users/haurhan/ts/idlejs/src/index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Works/Respite/respite_app/UI/~/idlejs/dist/index.js
// module id = ../../../../idlejs/dist/index.js
// module chunks = 4